import React, { useEffect, useState } from 'react';
import { API, getToken } from './adminApi';

// Everyone who left their email on a community's quick-match hero card
// ("Let me know when new members join who fit my details") — the pre-signup
// waiting list. Backend: GET /api/quick-match/admin/waitlist.
const fmt = (d) => (d ? new Date(d).toLocaleString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');
const fmtDay = (d) => (d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—');

const QuickMatchWaitlistTab = () => {
  const [entries, setEntries] = useState(null);
  const [error, setError] = useState('');
  const [communityId, setCommunityId] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const token = await getToken();
        const qs = communityId ? `?communityId=${encodeURIComponent(communityId)}` : '';
        const res = await fetch(`${API}/quick-match/admin/waitlist${qs}`, { headers: { Authorization: `Bearer ${token}` } });
        const json = await res.json();
        if (!res.ok) throw new Error(json.error);
        if (!cancelled) setEntries(json.entries);
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [communityId]);

  const communities = entries
    ? [...new Map(entries.map(e => [e.communityId, e.communityTitle])).entries()]
    : [];

  return (
    <div className="as-activity">
      {error && <div className="as-error">{error}</div>}
      <div className="as-activity-toolbar">
        <h2 className="as-section-title" style={{ margin: 0 }}>Quick-match waiting list ({entries ? entries.length : '…'})</h2>
        {communities.length > 1 && !communityId && (
          <select className="as-pa-select" value={communityId} onChange={e => setCommunityId(e.target.value)} aria-label="Community">
            <option value="">All communities</option>
            {communities.map(([id, title]) => <option key={id} value={id}>{title}</option>)}
          </select>
        )}
        {communityId && <button className="as-filter-tab" onClick={() => setCommunityId('')}>Show all communities</button>}
      </div>
      <p className="as-pa-hint">
        People who answered a community&apos;s quick-match card before signing up and asked to be told when someone who fits joins.
      </p>
      {!entries && !error && <div className="as-loading">Loading…</div>}
      {entries && (
        <div className="as-act-table-wrap">
          <table className="as-act-table">
            <thead>
              <tr><th>When</th><th>Email</th><th>Community</th><th>Where</th><th>Their answers</th><th>Matches shown</th><th>Since joined?</th><th>Deleted on</th></tr>
            </thead>
            <tbody>
              {entries.length === 0 && <tr><td colSpan="8" className="as-act-empty">No one yet</td></tr>}
              {entries.map(e => (
                <tr key={e._id}>
                  <td className="as-act-time">{fmt(e.at)}</td>
                  <td><a href={`mailto:${e.email}`}>{e.email}</a></td>
                  <td>{e.communityTitle}</td>
                  <td>{e.localArea || '—'}</td>
                  <td style={{ fontSize: '0.85rem' }}>
                    {Object.entries(e.answers).map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`).join(' · ') || '—'}
                  </td>
                  <td className="as-pa-num">{e.matchCount}</td>
                  <td>
                    {e.joined
                      ? (e.joined.inThisCommunity ? `✅ ${e.joined.firstName || 'Yes'}` : `Has an account (${e.joined.firstName || 'name not set'}), not in this group`)
                      : 'Not yet'}
                  </td>
                  <td className="as-act-time">{fmtDay(e.deleteAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default QuickMatchWaitlistTab;
